import { render, staticRenderFns } from "./NewUserAction.vue?vue&type=template&id=d544fc54&scoped=true&"
import script from "./NewUserAction.vue?vue&type=script&lang=js&"
export * from "./NewUserAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d544fc54",
  null
  
)

export default component.exports